import classNames from 'classnames'
import { Link } from 'react-router-dom'

import Image from '../Image/Image'
import { getImageUrl, isLanguage } from '../../../utils'
import styles from './JoinningCard.module.scss'
import UpArrow from '../../../assets/images/arrowUpRight.svg'
import { useLanguage } from '../../../context/LangaugeContextProvider/LangaugeContextProvider'

const JoiningCard = ({ section3 }) => {
  const { language } = useLanguage()
  const { isFrench } = isLanguage(language?.code)
  const data = section3
  return (
    <div
      className={classNames(
        'page-container',
        styles['teamcard'],
        'grid grid-cols-1 md:grid-cols-2 '
      )}
    >
      <div className="flex items-center justify-center">
        <Image
          src={getImageUrl(data?.image)}
          alt={data?.image?.alternativeText}
        />
      </div>
      <div className="flex sm:items-center items-start justify-center">
        <div className={styles.joinCard}>
          <div
            className={classNames(
              styles.title,
              isFrench ? styles.fr_title : ''
            )}
          >
            {data?.title}
            <br />
            <p className={styles.description}>{data?.description}</p>
          </div>

          <Link
            to={data?.link?.path}
            className={classNames('flex flex-row items-center', styles.link)}
          >
            <p className={styles.sendTxt}> {data?.link?.label}</p>
            <Image
              src={UpArrow}
              alt="sendicon"
              className={classNames(
                styles['action-image'],
                'block cursor-pointer'
              )}
            />
          </Link>
        </div>
      </div>
    </div>
  )
}
export default JoiningCard
